import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.d5x_1 = call;
        this.e5x_1 = data.j5l_1;
        this.f5x_1 = data.i5l_1;
        this.g5x_1 = data.l5l_1;
        this.h5x_1 = data.k5l_1;
        this.i5x_1 = data.n5l_1;
      }
      r5i() {
        return this.d5x_1;
      }
      ew() {
        return this.r5i().ew();
      }
      s5i() {
        return this.e5x_1;
      }
      t5i() {
        return this.f5x_1;
      }
      t2o() {
        return this.g5x_1;
      }
      l50() {
        return this.h5x_1;
      }
      l5i() {
        return this.i5x_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
